<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <!-- Widgets-->
      <v-flex d-flex lg3 sm6 xs12>
        <widget icon="group_work" :title="groups" subTitle= 'Groups' supTitle="" color="#00b297"/>
      </v-flex>
      <v-flex d-flex lg3 sm6 xs12>
        <widget icon="dns" :title="servers" subTitle= 'Servers' supTitle="" color="#dc3545"/>
      </v-flex>
      <v-flex d-flex lg3 sm6 xs12>
        <widget icon="border_all" :title="instances" subTitle= 'Instances' supTitle="" color="#0866C6"/>
      </v-flex>
      <v-flex d-flex lg3 sm6 xs12>
        <widget icon="block" :title="blacklist" subTitle= 'Blacklist' supTitle="" color="#1D2939"/>
      </v-flex>
      <!-- Widgets Ends -->
      <!-- Statistics -->
      <v-flex d-flex lg4 sm6 xs12>
        <site-view-statistic/>
      </v-flex>
      <v-flex d-flex lg4 sm6 xs12>
        <location-statistic/>
      </v-flex>
      <v-flex d-flex lg4 sm6 xs12>
        <total-earnings-statistic/>
      </v-flex>
      <!-- Statistics Ends -->
      <!-- DataTable&TimeLine Starts -->
      <v-flex d-flex lg8 sm6 xs12>
        <data-table/>
      </v-flex>
      <v-flex d-flex lg4 sm6 xs12>
        <time-line />
      </v-flex>
      <!-- DataTable&TimeLine Ends -->
      <v-flex d-flex lg6 sm6 xs12>
        <stepper/>
      </v-flex>
      <v-flex d-flex lg6 sm6 xs12>
        <user-tree-view />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      groups: "",
      servers: "",
      instances: "",
      blacklist: ""


    }
  },
    created () {
      this.get_statistics("groups")
      this.get_statistics("servers")
      this.get_statistics("instances")
      this.get_statistics("blacklist")

    },
   methods: {
        get_statistics (val) {
         if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}

          this.$http
              .get(this.$root.apiUrl+'/api/v1/statistic/'+ val)
              .then(r => {
                // console.log('r: ', JSON.stringify(r, null, 2));
                if(r.status === 200){
                  this[val] = r.data.count;
                }

      });
     }
   }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue